import { toaster } from 'uikit/Toaster'
import { useMutation } from '@tanstack/react-query'
import { api } from 'api'

export const useSettingsUpdate = () => {
  return useMutation({
    mutationFn: (data: any) => api.payments.updateSettings(data.id, data.data),
    onError: () => {
      toaster.create({
        title: 'Ошибка',
        description: 'Не удалось обновить настройки интервала платежей',
        type: 'error',
        duration: 9000,
        isClosable: true,
      })
    },
    onSuccess: () => {
      toaster.create({
        title: 'Готово',
        description: 'Настройки успешно обновлены',
        type: 'success',
      })
    }
  })
}
